import './RiskModal.scss';

export { default } from './RiskModal';
